<template>
	<div class="flying-button-wrapper w-limit context-menu"
	     v-on:click.self="onDropdownHide"
	     @hide="onDropdownHide"
	>
		<div class="flying-inside dropup"
		     v-on:click.self="onDropdownHide"
		     @hide="onDropdownHide"
		>
			<a class="flying-button-export offanimation" data-toggle="dropdown" data-display="static"></a>
			<div class="dropdown-menu"
			     v-on:click.self="onDropdownHide"
			     @hide="onDropdownHide"
			>
				<a class="dropdown-item" @click="doExport">
					<div class="icon-prefix"
					     style="background-image: url('../../../assets/icons/upload(1).svg')"></div>
					Ekspor Data
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOFABExport",
	methods: {
		doExport(payload) {
			this.$emit("export", payload)
		},
		onDropdownHide(bvEvent) {
			bvEvent.preventDefault();
		},
	}
}
</script>